<script>
import ScrollTable from './scrollTable'
import { getScreenSize } from 'common/js/dom'
const SIZE = getScreenSize()
const BLOCK_LIMIT_NUM = 20
const BLOCK_CATEGORY = [
  {
    text: '全部',
    value: 1
  },
  {
    text: '5岁的倍数',
    value: 5
  },
  {
    text: '10岁的倍数',
    value: 10
  }
]
export default {
  name: 'DemonTb',
  components: {
    ScrollTable
  },
  filters: {},
  mixins: [],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    mainIns: {
      type: Object,
      default () {
        return {}
      }
    },
    profit: {
      type: Array,
      default () {
        return []
      }
    },
    productData: {
      type: Object,
      default () {
        return {
          list: [],
          value: null
        }
      }
    },
    insuredAge: {
      type: Number,
      default: 0
    },
    startYear: {
      type: Number,
      default: 0
    },
    activeNavLeft: {
      type: Number,
      default: 0
    },
    accountBtnsText: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    this.blockBtns = BLOCK_CATEGORY
    return {
      blockIndex: 0
    }
  },
  computed: {
    isShow: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    profitMaxLen () {
      const { profit } = this
      const lenAry = profit.map(item => {
        return item.values.length
      })
      return profit[lenAry.indexOf(Math.max(...lenAry))].values.length
    },
    isBlockShow () {
      return this.profitMaxLen > BLOCK_LIMIT_NUM
    },
    list () {
      const { profit, profitMaxLen } = this
      // 分段显示数据处理
      const blockData = this.formatBlockData(profit, profitMaxLen)
      return blockData.map(item => {
        return {
          ...item,
          values: Array.from(
            { length: profitMaxLen },
            (val, index) => this.formatValue(item.values[index]) || '-'
          )
        }
      })
    },
    productList () {
      const { productData } = this
      return Array.isArray(productData.list) ? productData.list : []
    },
    productValue () {
      const { productData } = this
      return productData && productData.value
    },
    product () {
      const { productList, productValue } = this
      return productList.filter(item => item.productId === productValue)[0]
    },
    productIndex () {
      const { productList, productValue } = this
      return productList.findIndex(item => item.productId === productValue)
    },
    isConditionShow () {
      const { product } = this
      return !!(product && (product.bonus || product.rate))
    },
    isBonusAndRateShow () {
      const { product } = this
      return product && product.bonus && product.rate
    },
    isRateShow () {
      const { product } = this
      return product && product.rate && !product.bonus
    },
    isBonusShow () {
      const { product } = this
      return product && product.bonus && !product.rate
    }
  },
  watch: {
    isShow: function (v) {
      this.$nextTick(this.setScrollLeft.bind(this, v))
    }
  },
  methods: {
    formatOptions (str) {
      return str.split('<br>').join(' ')
    },
    formatValue (val) {
      return val === '*' ? val : isNaN(val) ? '-' : Math.round(parseFloat(val))
    },
    formatBlockData (profit, maxLen) {
      const profitTmp = JSON.parse(JSON.stringify(profit))
      if (!this.isBlockShow) return profitTmp
      const {
        mainIns,
        insuredAge,
        startYear,
        blockIndex,
        blockBtns,
        profitMaxLen
      } = this
      const blockVal = blockBtns[blockIndex].value
      let year = this.getNumberFromYear(mainIns.pPeriod)
      if (typeof mainIns.pPeriod === 'string' && mainIns.pPeriod.match(/^b/)) {
        year += insuredAge + startYear
      }

      profitTmp.forEach(item => {
        const maxArray = Array.from({ length: profitMaxLen })
        item.values = maxArray.map((v, index) => {
          const val = item.values[index] || '-'
          const trueAge = insuredAge + startYear + index + 1
          if (profitMaxLen - 1 === index || trueAge <= year) {
            return val
          }
          return trueAge % blockVal === 0 ? val : '*'
        })
      })
      return profitTmp
    },
    getNumberFromYear (value, age = 0) {
      let num = null
      if (!value) {
        return num
      }
      if (typeof value === 'number') {
        return value
      }
      if (value === 'a1000') {
        num = 1
      } else if (value.match(/^a/)) {
        num = value.replace(/\D/g, '') * 1 - age
      } else {
        num = value.replace(/\D/g, '') * 1
      }
      return num
    },
    // 切换产品
    changeProductHandler (index) {
      this.$emit('tb-product-change', index)
    },
    // 切换追加领取
    changePartHandler (index) {
      if (!this.accountBtnsText.length) return
      this.$emit('part-change', index)
    },
    // 切换利率
    setRateHandler () {
      let {
        product: {
          rate: { value }
        },
        productIndex
      } = this
      this.$emit('tb-rate-change', value, productIndex)
    },
    // 切换分红
    setBonusHandler () {
      let {
        product: {
          bonus: { value }
        },
        productIndex
      } = this
      this.$emit('tb-bonus-change', value, productIndex)
    },
    setScrollLeft (outSet) {
      if (!this.$refs.navigation) return
      const closeBtnWidth = SIZE.width * (45 / 750)
      if (outSet) {
        this.$refs.navigation.scrollLeft = this.activeNavLeft + closeBtnWidth
      } else {
        const navDom = document.querySelector(
          '.demonstration-container .navigation'
        )
        if (!navDom) return
        navDom.scrollLeft = this.$refs.navigation.scrollLeft
      }
    }
  }
}
</script>
<template>
  <scroll-table
    v-model="isShow"
    title="利益演示表格"
    :list="list"
    :age-index="insuredAge + startYear"
  >
    <!-- product -->
    <div class="navigation-wrap after-bd-b">
      <div
        ref="navigation"
        class="navigation"
        :class="{ 'after-bd-b': productList.length <= 3 }"
        @touchmove.stop
      >
        <nav class="nav">
          <a
            v-for="(pd, index) in productList"
            :key="index"
            href="javascript:;"
            class="item needsclick"
            :class="{ cur: productValue === pd.productId }"
            @click="changeProductHandler(index)"
          >{{ formatOptions(pd.productName) }}</a>
        </nav>
      </div>
    </div>

    <div v-if="isConditionShow" class="condition" @touchmove.stop.prevent>
      <!-- addTake -->
      <div v-if="accountBtnsText.length" ref="addTake" class="add-take-reduce">
        <div class="inner">
          <a
            v-for="(item, index) in accountBtnsText"
            :key="index"
            href="javascript:;"
            :class="{ cur: index === productData.part }"
            @click.stop.prevent="changePartHandler(index)"
          >{{ item }}</a>
        </div>
      </div>
      <!-- all -->
      <div
        v-if="isBonusAndRateShow"
        class="profit-condition demon-tb-condition condition-multiple"
        :class="{ gap: !accountBtnsText.length }"
      >
        <h6>分红水平</h6>
        <div class="bonus-condition">
          <span
            v-for="(curPd, index) in product.bonus.opts"
            :key="index"
            class="profit-item"
          >
            <input
              v-model="product.bonus.value"
              type="radio"
              name="tb-bonus"
              :value="curPd.value"
              @change.stop="setBonusHandler"
            >
            <label class="profit-label after-bdr" for>
              <p class="profit-label-in" v-html="curPd.description" />
            </label>
          </span>
        </div>
        <h6>结算利率</h6>
        <div class="rate-condition">
          <span
            v-for="(curPd, index) in product.rate.opts"
            :key="index"
            class="profit-item"
          >
            <input
              v-model="product.rate.value"
              type="radio"
              name="tb-rate"
              :value="curPd.value"
              @change.stop="setRateHandler"
            >
            <label for class="profit-label after-bdr">
              <template v-if="/\$/.test(curPd.description)">
                <p v-html="curPd.description.split('$')[0]" />
                <p v-html="curPd.description.split('$')[1]" />
              </template>
              <template v-else>
                <p v-html="`${(curPd.value * 100).toFixed(2)}%`" />
                <p v-html="curPd.description" />
              </template>
            </label>
          </span>
        </div>
      </div>
      <!-- Bonus -->
      <div
        v-if="isBonusShow"
        class="bonus-wrap profit-condition demon-tb-condition"
      >
        <span
          v-for="(curPd, index) in product.bonus.opts"
          :key="index"
          class="profit-item"
        >
          <input
            v-model="product.bonus.value"
            type="radio"
            name="tb-bonus"
            :value="curPd.value"
            @change.stop="setBonusHandler"
          >
          <label class="profit-label after-bdr" for="tb-bonus">
            <p class="profit-label-in" v-html="curPd.description" />
          </label>
        </span>
      </div>
      <!-- Rate -->
      <div
        v-if="isRateShow"
        class="rate-wrap profit-condition demon-tb-condition"
      >
        <span
          v-for="(curPd, index) in product.rate.opts"
          :key="index"
          class="profit-item"
        >
          <input
            v-model="product.rate.value"
            type="radio"
            name="tb-rate"
            :value="curPd.value"
            @change.stop="setRateHandler"
          >
          <label for class="profit-label after-bdr">
            <template v-if="/\$/.test(curPd.description)">
              <p v-html="curPd.description.split('$')[0]" />
              <p v-html="curPd.description.split('$')[1]" />
            </template>
            <template v-else>
              <p v-html="`${(curPd.value * 100).toFixed(2)}%`" />
              <p v-html="curPd.description" />
            </template>
          </label>
        </span>
      </div>
    </div>

    <template v-if="isBlockShow" slot="footer">
      <div class="block-btn">
        <div class="block-fixed">
          <a
            v-for="(item, index) in blockBtns"
            :key="index"
            class="after-bdr"
            :class="{ cur: blockIndex === index }"
            href="javascript:;"
            @click="blockIndex = index"
          >{{ item.text }}</a>
        </div>
      </div>
    </template>
  </scroll-table>
</template>
<style lang="postcss" scoped>
.block-btn {
  height: 1rem;
}
.block-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  padding-top: 0.13rem;
  padding-left: 0.21rem;
  padding-right: 0.21rem;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  border-bottom: 0.13rem solid #f7f7f7;
  font-size: 0.26rem;
  text-align: center;
  background-color: #f7f7f7;
  > a {
    flex: 1;
    margin: 0 0.09rem;
    padding: 0.17rem 0;
    color: #333;
    background-color: #fff;
    outline: none;
    &::after {
      border-radius: 0.24rem;
    }
  }
}

.demon-tb-condition {
  padding: 0.2rem 0.28rem 0;
  margin: 0 auto;
  > h6:first-child {
    padding-top: 0;
  }
}

.condition {
  padding-bottom: 0.2rem;
  text-align: center;
  .bonus-wrap,
  .rate-wrap {
    &:after {
      border-radius: 6px;
    }
    .condition-sel {
      z-index: 1;
      position: relative;
      min-width: 115px;
      padding: 5px 25px 5px 10px;
      font-size: 15px;
      border: 0;
      vertical-align: middle;
      appearance: none;
      background: transparent;

      -webkit-tap-highlight-color: transparent;
    }
    .icon-arrow_down {
      z-index: 1;
      position: absolute;
      right: 8px;
      top: 50%;
      font-size: 12px;
      line-height: 1;
      pointer-events: none;
      transform: translateY(-50%) scale(0.7);
    }
  }
}

.add-take-reduce {
  padding: 0.2rem 0.2rem 0;
  text-align: center;
  .inner {
    overflow-x: auto;
    width: 70%;
    margin: 0 auto;
    border-width: 1px;
    border-style: solid;
    font-size: 0;
    border-radius: 10rem;
    white-space: nowrap;
    &::-webkit-scrollbar {
      width: 0px;
      display: none;
    }
    a {
      display: inline-block;
      width: 50%;
      padding: 0.18rem 0.24rem;
      font-size: 0.3rem;
      text-decoration: none;
      border-radius: 10rem;
    }
  }
}

.condition-multiple {
  display: block;
  > h6 {
    padding-top: 12px;
    padding-bottom: 9px;
    color: #333;
    font-size: 12px;
    text-align: left;
  }
  .bonus-condition,
  .rate-condition {
    display: flex;
  }
  .bonus-condition {
    .profit-item {
      .profit-label {
        padding: 7px;
        p {
          line-height: 1.2;
        }
      }
    }
  }
}
</style>
